import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTenant } from './TenantContext';
import { presetBrand } from '../util/presetBrand';
import { applyPresetRobots } from '../util/presetRobots';

/**
 * Keeps the robots meta tag and the canonical right on every route, for a
 * tenant on a marketing-site preset only (util/presetRobots.ts). Renders
 * nothing, and for a tenant without a preset - Go Oil included - does nothing
 * at all.
 */
export default function PresetRobots() {
  const tenant = useTenant();
  const { pathname } = useLocation();
  const hasPreset = !!presetBrand(tenant?.themePreset);

  useEffect(() => {
    if (hasPreset) applyPresetRobots(pathname);
  }, [hasPreset, pathname]);

  return null;
}
